import { isValidElement } from 'react';
import { isFragment as isReactFragment } from 'react-is';
export default function isFragment(value) {
    return isReactFragment(value) || (isValidElement(value) && value.type === 'fragment');
}
